function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-1517.501 -491.499)"
}, React.createElement("circle", {
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  transform: "translate(1520.668 494.667)",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M1524.4 495.118c0 1.925-3.2 4.882-3.2 4.882s-3.2-2.957-3.2-4.882a3.2 3.2 0 016.4 0z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeMiterlimit: 10
}));

var SvgPin = function SvgPin(props) {
  return React.createElement("svg", _extends({
    width: 7.404,
    height: 9.186
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjQwNCIgaGVpZ2h0PSI5LjE4NiIgdmlld0JveD0iMCAwIDcuNDA0IDkuMTg2Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUxNy41MDEgLTQ5MS40OTkpIj48Y2lyY2xlIGN4PSIwLjUiIGN5PSIwLjUiIHI9IjAuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUyMC42NjggNDk0LjY2NykiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz48cGF0aCBkPSJNMjQuNCwxOC4xMThDMjQuNCwyMC4wNDMsMjEuMiwyMywyMS4yLDIzUzE4LDIwLjA0MywxOCwxOC4xMThhMy4yLDMuMiwwLDAsMSw2LjQsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1MDAgNDc3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9nPjwvc3ZnPgo=";
export { SvgPin as ReactComponent };